module.exports = __webpack_public_path__ + "filter_list-v1-9bee6b17.svg";